import React, { useRef, useState } from 'react';
import Pause from '../image/pause-button.png';
import Play from '../image/play.png';
import Mute from '../image/silent.png';
import Volume from '../image/volume.png';

const AutoPlayVideo = ({ src, alt }) => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);

  const toggleMute = () => {
    if (videoRef && videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  }

  const togglePlayPause = () => {
    if (videoRef && videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  }

  return (
    <div className=" relative">
      <video
        ref={videoRef}
        className='bg-gray shadow-lg shadow-gray rounded lg:hover:scale-150 transform transition-transform transition-500'
        autoPlay 
        muted={isMuted}
        loop
      >
        <source src={src} type="video/mp4" />
        {alt}
      </video>
      <div className="absolute  flex flex-col gap-5 py-2 px-2 top-[60%] left-[90%] ">
        <button 
          className=" text-white font-bold rounded"
          onClick={toggleMute}
        >
          {isMuted ? <img src={Mute} className='w-6 h-6' alt='mute'/> : <img src={Volume} className='w-6 h-6' alt='volume'/>}
        </button>
        <button 
          className="text-white font-bold rounded"
          onClick={togglePlayPause}
        >
          {isPlaying ? <img src={Pause} className='w-6 h-6' alt='pause' /> : <img src={Play} className='w-6 h-6' alt='play' />}
        </button>
      </div>
    </div>
  );
}

export default AutoPlayVideo;

